// TES-1294 — "Mötesstöd": the small meeting overview beside the journal,
// never part of it. A-02 (2026-10-13):
//   "Ingen separat checklista ska duplicera journalen. Operativ information
//    som inte ska journalföras, exempelvis information om hur fortsatt stöd
//    fungerar, kan visas i en liten separat mötesöversikt."
// So it holds only operational, non-journal lines: what to tell her about
// how the support works, and what is left to do after the meeting. Medical
// checks stay in the journal headings and FlagsAndMissingBasis.
//
// Pure on purpose: no React, no path aliases. The unit tests in
// `apps/admin/test` run it with plain `node --test`.

export interface MeetingSupportInput {
  /** TES-1228 — a meeting she booked herself: no decision, no notice. */
  voluntary: boolean;
  /** The completion picker's outcome, as chosen so far. */
  outcome: string | null;
  /** Whether the picker asked for a new blood test (meetingNeedsLabOrder). */
  needsLabOrder: boolean;
}

export interface MeetingSupportLists {
  /** "Information att förmedla" */
  inform: string[];
  /** "Åtgärder efter mötet" */
  after: string[];
}

export const MEETING_SUPPORT_DIN_VARD =
  "Hur fortsatt stöd fungerar: patienten hittar informationen under Din vård i appen.";

export function meetingSupportLists(
  input: MeetingSupportInput,
): MeetingSupportLists {
  const after = ["För in journalanteckningen i Webdoc."];
  if (!input.voluntary && input.needsLabOrder) {
    after.push("Skapa provbeställning/remiss för blodprov i Webdoc.");
  }
  if (!input.voluntary && input.outcome === "proceed") {
    after.push("Skriv receptet i Webdoc när behandlingen godkänns.");
  }
  if (!input.voluntary) {
    after.push("Publicera beskedet till patienten i sista steget.");
  }
  return { inform: [MEETING_SUPPORT_DIN_VARD], after };
}
